<template>
  <router-view />
</template>

<script>
export default {
  name: 'Endpoint',
}
</script>
